import { render } from "./Extensions.vue?vue&type=template&id=4ae0dc72&scoped=true&ts=true"
import script from "./Extensions.vue?vue&type=script&lang=ts"
export * from "./Extensions.vue?vue&type=script&lang=ts"

import "./Extensions.vue?vue&type=style&index=0&id=4ae0dc72&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ae0dc72"]])

export default __exports__